import React from 'react'
import UserReflection from './user-reflection'
import UserCourseSurvey from './user-course-survey'
import UserFacilitatorSurvey from './user-facilitator-survey'

const Inquiries = ({ children }) => {

    return (
        <UserReflection>
            <UserCourseSurvey>
                <UserFacilitatorSurvey>
                    {children}
                </UserFacilitatorSurvey>
            </UserCourseSurvey>
        </UserReflection>
    )
}

export default Inquiries
